import React, { Component } from 'react'

class MiniCarrierTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data:[]
        }
    }
    componentWillReceiveProps(newProps) {
        console.log('newProps :>> ', newProps);
        this.setState({
            data:newProps.table
        })
    }

    renderTable() {
        const {data} = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (data === null || data === undefined) {
            return nullData
        }
        else {
            return data.map((row, idx) => {
                return (
                    <tr key={idx} >
                        <td className='table-data'>{row.name}</td>
                <td className='table-data'>{row.code === 200 ? <p className="text-success">{row.code}</p> : <p className="text-danger">{row.code}</p>}</td>
                        <td className='table-data'>{row.reason}</td>
                        
                    </tr>
                )
            })
        }
    }
    
    render() {
        return (
            <div>
                <div className="datatable-scroll " style={{ overflowX: 'auto' }}>
                    <table className="table-style table table-striped dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                        <thead>
                            <tr className="stickeyHeader table-heading-style">
                                <th>Name</th>
                                <th>Reason</th>
                                <th>Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderTable()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
export default MiniCarrierTable